<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>-巡检点列表</b></p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="addClick">新增巡检点</el-button>
            </p>
        </div>

        <el-table :data="patrolPointList" style="width: 100%" @select="selectClick" @row-click="rowClick"
            ref="patrolPointTable" highlight-current-row>
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>

            <el-table-column prop="patrolPointCode" label="巡检点编号" min-width="20%">
            </el-table-column>

            <el-table-column prop="patrolPointName" label="巡检点名称" min-width="20%">
            </el-table-column>

            <el-table-column prop="patrolCycleDesc" label="巡检周期" min-width="10%">
            </el-table-column>
            <el-table-column prop="patrolCount" label="巡检次数" min-width="10%" align="center">
            </el-table-column>

            <el-table-column prop="intervalTime" label="间隔时间(h)" min-width="10%" align="center">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="240">
                <template slot-scope="scope">
                    <el-button @click="printClick(scope.row)" type="success" round size="small">
                        二维码
                    </el-button>
                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        更改
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="danger" round size="small">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount" layout="total, sizes,prev, pager, next"
                :total="total" @current-change="pageClick" :page-sizes="[10, 15, 20, 25]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-dialog title="巡检点详情" :visible.sync="dlgFormVisible" width="45%">

            <div style="display:flex;margin-bottom: 10px;">
                <p style="display:inline;width:15%">* 上传图片</p>
                <div style="display:inline-block;width:25%">
                    <el-upload class="avatar-uploader" action="#" :http-request="upload" :show-file-list="false"
                        :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">

                        <img v-if="form.imgUrl" :src="'https://' + imagePath + form.imgUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>

                    </el-upload>
                </div>

                <div style="width:60%">
                    <div style="display:flex;margin-bottom: 40px;">
                        <p style="display:inline;width:30%">* 巡检点编号</p>
                        <div style="display:inline;width:70%">
                            <el-input v-model="form.patrolPointCode" autocomplete="off" style="width:100%"
                                :disabled="patrolCodeDisable"></el-input>
                        </div>
                    </div>

                    <div style="display:flex;margin-bottom: 10px;">
                        <p style="display:inline;width:30%">* 巡检点名称</p>
                        <div style="display:inline;width:70%">
                            <el-input v-model="form.patrolPointName" autocomplete="off" style="width:100%"></el-input>
                        </div>
                    </div>

                </div>
            </div>

            <div style="display:flex;margin-bottom: 10px;">
                <p style="display:inline;width:15%">* 绑定设备</p>
                <div style="display:inline;width:30%">
                    <el-select v-model="form.equipmentCode" placeholder="请选择" style="width:100%" @change="equipChange"
                        :disabled="equipCodeDisable">
                        <el-option v-for="item in form.equipmentList" :key="item.value" :label="item.equipmentCode"
                            :value="item.equipmentCode">
                        </el-option>
                    </el-select>
                </div>

                <div style="width:10%"></div>

                <p style="display:inline;width:15%">* 巡检周期</p>
                <div style="display:inline;width:30%">
                    <el-select v-model="form.patrolCycle" placeholder="请选择" style="width:100%" @change="cycleChange">
                        <el-option v-for="item in form.cycleList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>

            <div style="display:flex;margin-bottom: 10px;">
                <p style="display:inline;width:15%">* 巡检次数</p>
                <div style="display:inline;width:30%">
                    <el-input-number v-model="form.patrolCount" :step="1" :min="1" style="width:100%"
                        @change="countChange"></el-input-number>
                </div>

                <div style="width:10%"></div>

                <p style="display:inline;width:15%">最短间隔时间(h)</p>
                <div style="display:inline;width:30%">
                    <el-input-number v-model="form.intervalTime" :precision="1" :step="0.1" :min="0.1"
                        style="width:100%"></el-input-number>
                </div>
            </div>

            <div style="display:flex;margin-bottom: 10px;">
                <p style="display:inline;width:15%">备注</p>
                <div style="display:inline;width:85%">
                    <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width:100%"></el-input>
                </div>
            </div>

            <div style="display:flex;margin-bottom: 10px;">
                <p style="display:inline;width:15%">* 巡检项目</p>
                <div style="display:inline;width:85%">
                    <el-select v-model="form.inspectionNameArr" multiple placeholder="请选择" style="width:100%"
                        @change="inspectionItemChange">
                        <el-option v-for="item in form.inspectionList" :key="item.id" :label="item.inspectionName"
                            :value="item.inspectionName">
                        </el-option>
                    </el-select>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dlgFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="savePatrolClick('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="打印二维码" :visible.sync="printDlgVisible" width="50%">
            <div id="barcode-img" v-html="barcodeUrl"></div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="printDlgVisible = false">取 消</el-button>
                <el-button type="primary" @click="printBarcode(1)">打 印</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: "PatrolPoint",
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),
            imagePath: this.getImagePath(),
            queryValue: '',

            pageIndex: 0,
            pageNum: 10,
            total: 0,
            pageCount: 0,

            patrolPointList: [],

            dlgFormVisible: false,

            printDlgVisible: false,

            patrolCodeDisable: true,
            equipCodeDisable: true,

            form: {
                id: '',
                imgUrl: '',
                imgFile: null,
                patrolPointCode: '',
                patrolPointName: '',

                equipmentCode: '',
                equipmentList: [],

                patrolCycle: 0,
                cycleList: [{
                    label: '每日',
                    value: 0
                }, {
                    label: '每周',
                    value: 1
                }, {
                    label: '每月',
                    value: 2
                }],
                patrolCount: 1,
                intervalTime: 24,

                inspectionIdArr: [],
                inspectionNameArr: [],
                inspectionList: [],
                remark: ''
            },

            selectedEquipRow: {},

            equipmentId: '',
            equipmentCode: '',
            processId: '',

            productProcessThree: '',
            processQueueThree: null,

            inspectionPicOne: '',
            remark: '',
            processInspection: {},

            inspectionItemList: []
        }
    },
    methods: {
        selectClick(selection, row) {
            this.rowClick(row)
        },
        rowClick(row) {
            
            this.$refs.patrolPointTable.clearSelection()
            this.$refs.patrolPointTable.toggleRowSelection(row)
        },
        getAllPatrolPoint() {

            this.$axios({
                method: "post",
                url: "/shiro/patrol/point/getAll",
                data: {
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.patrolPointList = data.data
                this.total = this.patrolPointList[0].total
                for (let i in this.patrolPointList) {

                    if (this.patrolPointList[i].patrolCycle == 0) {
                        this.patrolPointList[i].patrolCycleDesc = '每日'
                    } else if (this.patrolPointList[i].patrolCycle == 1) {
                        this.patrolPointList[i].patrolCycleDesc = '每周'
                    } else if (this.patrolPointList[i].patrolCycle == 2) {
                        this.patrolPointList[i].patrolCycleDesc = '每月'
                    } else {
                        this.patrolPointList[i].patrolCycleDesc = '每年'
                    }
                }

            })
        },
        getAllEquipment() {

            this.$axios({
                method: "post",
                url: "/shiro/equipment/getAll",
                data: {
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.form.equipmentList = data.data
            })

        },
        getAllInspection() {
            this.$axios({
                method: "post",
                url: "/shiro/base/inspection/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.form.inspectionList = data.data
            })
        },
        addClick() {

            this.patrolCodeDisable = false
            this.equipCodeDisable = false

            this.form.id = ''

            this.form.imgUrl = ''
            this.form.imgFile = null

            this.form.patrolPointCode = ''
            this.form.patrolPointName = ''

            this.form.equipmentCode = ''

            this.form.patrolCycle = 0
            this.form.patrolCount = 1
            this.form.intervalTime = 24

            this.form.remark = ''

            this.form.inspectionNameArr = []

            this.getAllInspection()

            this.dlgFormVisible = true
        },
        equipChange(value) {

            this.form.equipmentCode = value
        },
        inspectionItemChange(val) {

            this.form.inspectionIdArr = []
            for (let i in val) {

                const index = this.form.inspectionList.findIndex(obj => obj.inspectionName == val[i])

                this.form.inspectionIdArr.push(this.form.inspectionList[index].id)
            }
            
        },
        upload(f) {
            
            this.form.imgFile = f.file
            this.form.imgUrl = ''
        },
        savePatrolClick() {

            const form = new FormData()

            form.append('id', this.form.id)

            if (this.form.imgFile != null) {
                form.append('imgFile', this.form.imgFile)
            }

            if (this.form.patrolPointCode == '' || this.form.inspectionIdArr.length < 1) {
                this.$message({
                    type: 'info',
                    message: '请先完善必填项信息'
                })
                return
            }

            form.append('patrolPointCode', this.form.patrolPointCode)
            form.append('patrolPointName', this.form.patrolPointName)
            form.append('equipmentCode', this.form.equipmentCode)

            form.append('patrolCycle', this.form.patrolCycle)
            form.append('patrolCount', this.form.patrolCount)
            form.append('intervalTime', this.form.intervalTime)

            this.form.inspectionIdArr.forEach((value, index) => {
                form.append(`inspectionItemIdList[${index}]`, value)
            })

            form.append('remark', this.form.remark)
            form.append('companyId', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/patrol/point/add",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message({
                    type: 'info',
                    message: data.msg
                })

                this.getAllPatrolPoint()

                this.dlgFormVisible = false
            })

        },
        printClick(row) {
            var code = row.equipmentCode
            var path = '/equipment/barcode/'

            if (row.equipmentCode == null || row.equipmentCode == '') {
                code = row.patrolPointCode
                path = '/quality/barcode/'
            }

            this.barcodeUrl = "<div>" + code + "</div><img src='https://" + this.imagePath +
                this.companyId + path + code + ".png'>"

            this.printDlgVisible = true
        },
        printBarcode(fang) {
            var content = document.getElementById("barcode-img").innerHTML
            
            var sprnstr = "<!--startprint" + fang + "-->"
            var eprnstr = "<!--endprint" + fang + "-->"

            var iframe = document.createElement("IFRAME")
            
            var doc = null;
            iframe.setAttribute('style', 'position:absolute;width:0;height:0;left:-500px;top:-500px;')

            document.body.appendChild(iframe)
            doc = iframe.contentWindow.document
            doc.write(content)
            doc.close()
            iframe.contentWindow.focus()

            iframe.contentWindow.addEventListener('load', function () {
                
                iframe.contentWindow.print()
                document.body.removeChild(iframe)
            })

        },
        handleClick(row) {
            this.patrolCodeDisable = true
            this.equipCodeDisable = true

            this.form.id = row.id

            this.form.imgUrl = row.imgUrl
            this.form.imgFile = null

            this.form.patrolPointCode = row.patrolPointCode
            this.form.patrolPointName = row.patrolPointName

            this.form.equipmentCode = row.equipmentCode

            this.form.patrolCycle = row.patrolCycle
            this.form.patrolCount = row.patrolCount
            this.form.intervalTime = row.intervalTime

            this.form.remark = row.remark

            this.form.inspectionNameArr = []
            if (row.inspectionItemStr.indexOf(",") != -1) {
                this.form.inspectionNameArr = row.inspectionItemStr.split(",")
            } else {
                this.form.inspectionNameArr.push(row.inspectionItemStr)
            }

            this.form.inspectionIdArr = row.inspectionItemIdList

            this.getAllInspection()

            this.dlgFormVisible = true
        },
        removePatrolPoint(row) {

            this.$axios({
                method: "delete",
                url: "/shiro/patrol/point/remove",
                data: {
                    id: row.id,
                    patrolPointCode: row.patrolPointCode,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                this.getAllPatrolPoint()

                this.$message({
                    type: 'success',
                    message: '删除成功!'
                })
            })
        },
        deleteClick(row) {

            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removePatrolPoint(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        pageClick(currentPage) {
            this.patrolPointList = []

            this.pageIndex = (currentPage - 1) * this.pageNum

            this.getAllPatrolPoint()
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAllPatrolPoint()
        },
    },
    mounted() {
        this.setDefaultPath('/patrolPoint')

        this.getAllPatrolPoint()

        this.getAllEquipment()
    }
}
</script>

<style>
.avatar-uploader {
    width: 142px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
}

.avatar {
    width: 130px;
    height: 130px;
    display: block;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}
</style>